// Document status badge colors configuration
const documentStatusColor = {
    1: "bg-primary text-white",
    2: "bg-warning text-dark",
    3: "bg-info text-dark",
    4: "bg-danger text-white",
    5: "bg-success text-white",
    6: "bg-secondary text-white",
    "total": "bg-dark text-white" // for total badge rows
};


export default documentStatusColor;